import { render, staticRenderFns } from "./ConfettiRectangle.vue?vue&type=template&id=b5f2a7f2&lang=pug&"
import script from "./ConfettiRectangle.vue?vue&type=script&lang=js&"
export * from "./ConfettiRectangle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports